import goalSeek from "goal-seek";
import { getSimulation } from "..";

export interface IAmountCalculateParams {
  tenure: number;
  interestRate: number;
  loanDate: Date;
  dueDate: Date;
  isSimplesNacional: boolean;
  pmt: number;
  commissionRate?: number;
  commissionDiscount?: number;
}

export const calculateAmount = (params: IAmountCalculateParams) => {
  const {
    tenure,
    interestRate,
    loanDate,
    dueDate,
    isSimplesNacional,
    pmt,
    commissionRate,
    commissionDiscount
  } = params;
  const fn = (amount: number) =>
    getSimulation({
      amount,
      tenure,
      interestRate,
      isSimplesNacional,
      loanDate: loanDate,
      dueDate: dueDate,
      commissionRate,
      commissionDiscount
    }).pmt;
  const fnParams = [pmt * tenure];

  const amount = goalSeek({
    fn,
    fnParams,
    maxIterations: 5000,
    maxStep: 100,
    goal: pmt,
    independentVariableIdx: 0,
    percentTolerance: 0.001,
  });
  return Number(Math.round(amount).toFixed(2));
};
